import { createFileRoute } from "@tanstack/react-router";

import MonthlyPage from "@/admin/reports/monthly/page";

export const Route = createFileRoute("/app/$storeId/reports/monthly")({
    component: RouteComponent,
});

function RouteComponent() {
    return <MonthlyPage />;
}
